export * from './use-swr-document'
export * from './use-swr-collection'
export * from './static-mutations'
